exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!angular-ui-switch/angular-ui-switch.min.css"), "");

// module
exports.push([module.id, "toggle-switch .disabled{pointer-events:auto;width:35%}toggle-switch .switch{height:27px;width:53px}toggle-switch .switch small{height:24px;top:1px;width:24px}toggle-switch .switch.checked{background:#0072c9;border-color:#0072c9}toggle-switch .switch.checked small{left:28px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/toggleSwitch/toggleSwitch.scss
// module id = 711
// module chunks = 0